/**
 * Neville Goddard Voice Configuration
 * This voice is used for all lectures and books content generation
 */

export const NEVILLE_GODDARD_VOICE = {
  id: 'H42MeRDunc17uM624Bpd',
  displayName: 'Neville Goddard',
  type: 'elevenLabs',
  gender: 'male',
  locale: 'en-US',
  category: 'PRO',
  // Supported languages for this voice
  supportedLanguages: ['en', 'es'], // English and Spanish only
  // Audio generation settings
  audioSettings: {
    audioStyle: 'read',
    voiceType: 'elevenLabs'
  }
};

export const isNevilleGoddardVoiceSupported = (language) => {
  return NEVILLE_GODDARD_VOICE.supportedLanguages.includes(language);
};

export const getNevilleGoddardVoiceForLanguage = (language) => {
  if (isNevilleGoddardVoiceSupported(language)) {
    return NEVILLE_GODDARD_VOICE.id;
  }
  return null;
};